import { AfterContentChecked, Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';

@Directive({
  selector: '[appElementResize]'
})
export class ElementResizeDirective implements AfterContentChecked {

  @Input() addHeight: string;
  @Input() disabled = false;

  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {

  }

  ngAfterContentChecked(): void {
    this.resolveHeightElement();

  }

  @HostListener('window:resize', ['$event'])
  onresize(): void {
    if (this.disabled !== false) {
      this.resolveHeightElement();
    }
  }

  private resolveHeightElement() {
    const width = this.elementRef.nativeElement.offsetWidth;
    const addHeight = this.addHeight ? this.addHeight : '0';
    const height = (width / (16 / 9)) + Number(addHeight);
    this.renderer.setStyle(this.elementRef.nativeElement, 'height', `${height}px`);

  }
}
